import { render, staticRenderFns } from "./MailAdresse.vue?vue&type=template&id=440b6a48"
import script from "./MailAdresse.vue?vue&type=script&lang=js"
export * from "./MailAdresse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports